<template>
  <div class="pcm-a-wrapper" id="pcm-wrapper">
    <img src="@/assets/images/pc/pageA/logo.webp" alt="" class="logo" />
    <div class="pcm-a-contact-box">
      <img
        v-if="swUrl"
        class="pcm-a-contact"
        @click="toContact(swUrl)"
        src="@/assets/images/pc/pageA/business.webp"
        alt=""
      />
      <img
        v-if="qdUrl"
        class="pcm-a-contact"
        @click="toContact(qdUrl)"
        src="@/assets/images/pc/pageA/channel.webp"
        alt=""
      />
      <img
        v-if="tgUrl"
        class="pcm-a-contact"
        @click="toContact(tgUrl)"
        src="@/assets/images/pc/pageA/official.webp"
        alt=""
      />
    </div>
    <div class="pcm-a-title-box">
      <img src="@/assets/images/pc/pageA/title.webp" alt="" />
    </div>
    <div class="pcm-a-qr-box">
      <img class="qrcodeBox" :src="qrImg" alt="" />
    </div>
    <div class="pcm-a-user-box">
      <img src="@/assets/images/pc/pageA/user.webp" alt="" />
    </div>
  </div>
</template>

<script>
import autofit from "autofit.js";

export default {
  props: ["qrImg", "configs", "version", "ip", "switchData"],
  data() {
    return {
      tgUrl: "",
      potatoUrl: "",
      swUrl: "",
      qdUrl: ""
    };
  },
  watch: {
    configs: {
      immediate: true,
      handler(newValue) {
        this.applyConfigs(newValue || []);
      }
    }
  },
  mounted() {
    autofit.init(
      {
        dh: 1080,
        dw: 1920,
        el: "#pcm-wrapper",
        resize: true
      },
      false
    );
  },
  methods: {
    applyConfigs(configs) {
      this.tgUrl = "";
      this.potatoUrl = "";
      this.swUrl = "";
      this.qdUrl = "";

      configs.forEach(item => {
        if (item.configType == "tg_group") {
          this.tgUrl = item.link;
        } else if (item.configType == "potato_group") {
          this.potatoUrl = item.link;
        } else if (item.configType == "sw_cooperate") {
          this.swUrl = item.link;
        } else if (item.configType == "qd_cooperate") {
          this.qdUrl = item.link;
        }
      });
    },
    toContact(url) {
      window.open(url);
    }
  }
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}

.pcm-a-wrapper {
  width: 1920px;
  height: 1080px;
  overflow: hidden;
  position: relative;
  background: url("./../../../assets/images/pc/pageA/bg.webp") no-repeat center;
  background-size: 100% 100%;
  // autofit 只锁定 1920 宽，高度会被拉伸到窗口高度，纵向一律用百分比跟随背景
  .logo {
    width: 162px;
    height: auto;
    position: absolute;
    top: 3.611%;
    left: 46px;
    z-index: 20;
    object-fit: contain;
  }
  .pcm-a-contact-box {
    position: absolute;
    top: 4.074%;
    right: 21px;
    display: flex;
    gap: 18px;
    z-index: 20;
    img {
      width: 167px;
      height: 45px;
      cursor: pointer;
    }
  }
  .pcm-a-title-box {
    position: absolute;
    top: 100px;
    left: 0;
    width: 1024px;
    height: 666px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .pcm-a-qr-box {
    width: 670px;
    height: 250px;
    position: absolute;
    top: 75.278%;
    left: 143px;
    z-index: 8;
    display: flex;
    align-items: center;
    background: url("./../../../assets/images/pc/pageA/qrcode-bg.webp")
      no-repeat center;
    background-size: 100% 100%;
    position: relative;
    .qrcodeBox {
      position: absolute;
      top: 24px;
      left: 28px;
      width: 190px;
      height: 190px;
      display: block;
    }
  }
  .pcm-a-user-box {
    position: absolute;
    bottom: 0;
    right: 230px;
    width: 808px;
    height: auto;
    img {
      width: 100%;
      height: auto;
    }
  }
}
</style>
